import React, { useState, useEffect } from 'react';
import { Sun, Moon } from 'lucide-react';
import { toast } from '../utils/toast';

export default function ThemeToggle() {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("app-theme") || "dark";
  });

  useEffect(() => {
    // Apply initial theme on mount
    document.documentElement.setAttribute("data-theme", theme);
  }, []); // Only run once to set initial, the toggle function handles the rest

  const handleToggle = () => {
    const newTheme = theme === "dark" ? "light" : "dark";
    setTheme(newTheme);
    document.documentElement.setAttribute("data-theme", newTheme);
    localStorage.setItem("app-theme", newTheme);
    toast.success(`Switched to ${newTheme === "light" ? "Light" : "Dark"} theme`);
  };

  return (
    <button
      onClick={handleToggle}
      onMouseOver={(e) => {
        e.currentTarget.style.transform = 'scale(1.1)';
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
      }}
      style={{
        width: '40px', height: '40px', borderRadius: '50%',
        backgroundColor: 'var(--card-bg)', border: '1px solid var(--card-border)',
        color: 'var(--text-secondary)', cursor: 'pointer',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        boxShadow: 'var(--shadow-modal)', transition: 'all 0.2s cubic-bezier(0.16, 1, 0.3, 1)',
        marginRight: '8px'
      }}
      title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
    >
      {theme === "dark" ? <Sun size={24} /> : <Moon size={24} />}
    </button>
  );
}
